import axiosPost from "../axiosPost";

export const SFLocalidadGet = async (params = {}, credentials) => {
    const body = {
        service: "SFLocalidadGet",
        params: {
            provinciaId: params?.provinciaId ?? null,
        },
    };

    return await axiosPost(body, credentials);
};
